
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18.01 18.01"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.918.008c-1.554 0-2.84 1.274-2.828 2.827l.002.257h-.26A2.839 2.839 0 00.004 5.92v9.253a2.839 2.839 0 002.828 2.828h9.258a2.839 2.839 0 002.828-2.828v-.259l.257.002c1.554.016 2.829-1.274 2.829-2.827V2.835A2.839 2.839 0 0015.175.008zm0 1.542h9.257c.726 0 1.286.56 1.286 1.285v9.254c0 .725-.56 1.285-1.286 1.285h-.257V5.92a2.839 2.839 0 00-2.828-2.828H4.63l.002-.257A1.27 1.27 0 015.918 1.55zM2.832 4.635h9.258c.725 0 1.285.56 1.285 1.285v9.253c0 .726-.56 1.286-1.285 1.286H2.832c-.725 0-1.285-.56-1.285-1.286V5.92c0-.726.56-1.285 1.285-1.285z","font-family":"sans-serif","overflow":"visible"}})])
          )
        }
      }
    